export enum EDPEX_PROJECT_STATUS {
    DRAFT = 'DRAFT', // ร่าง
    PENDING_PROCESS = 'PENDING_PROCESS', // รอดำเนินการ
    PROCESS = 'PROCESS', // กำลังดำเนินการ
    OVERDUE = 'OVERDUE', // เกินกำหนดระยะเวลา
    COMPLETED = 'COMPLETED', // ดำเนินการเสร็จสิ้น
}

export enum EDPEX_PROJECT_USER_RESPONSIBLE {
    ADMIN = 'รองบริหาร',
    RESEARCH_AND_ACADEMIC = 'รองวิจัยและวิชาการ'
}

export enum EDPEX_PROJECT_DIVISION_RESPONSIBLE {
    ACADEMIC = 'วิชาการ',
    ADMINISTRATIVE = 'บริหาร'
}

type filterData = {
    label: string, value: string;
}
export enum EDPEX_PROJECT_DEPARTMENT_RESPONSIBLE {
    ACADEMIC_OFFICE = 'สำนักงานวิชาการ',
    COLLEGE_OFFICE = 'สำนักงานวิทยาลัย'
}

export const ed_pex_department_responsible: filterData[] = [
    {
        label: "สำนักงานวิชาการ",
        value: EDPEX_PROJECT_DEPARTMENT_RESPONSIBLE.ACADEMIC_OFFICE
    },
    {
        label: "สำนักงานวิทยาลัย",
        value: EDPEX_PROJECT_DEPARTMENT_RESPONSIBLE.COLLEGE_OFFICE
    },
]
export const ed_pex_project_user_responsible: filterData[] = [
    {
        label: "รองบริหาร",
        value: EDPEX_PROJECT_USER_RESPONSIBLE.ADMIN
    },
    {
        label: "รองวิจัยและวิชาการ",
        value: EDPEX_PROJECT_USER_RESPONSIBLE.RESEARCH_AND_ACADEMIC
    },
]
export const ed_pex_project_status_data: { label: string, value: string }[] = [
    {
        label: "บันทึกร่าง",
        value: EDPEX_PROJECT_STATUS.DRAFT
    },
    {
        label: "รอดำเนินการ",
        value: EDPEX_PROJECT_STATUS.PENDING_PROCESS
    },
    {
        label: "กำลังดำเนินการ",
        value: EDPEX_PROJECT_STATUS.PROCESS
    },
    {
        label: "เกินกำหนดระยะเวลา",
        value: EDPEX_PROJECT_STATUS.OVERDUE
    },
    {
        label: "ดำเนินการเสร็จสิ้น",
        value: EDPEX_PROJECT_STATUS.COMPLETED
    },
]



export enum EDPEX_PROJECT_AMENDMENT_NAME {
    DURATION = 'ขอปรับเปลี่ยนระยะเวลาเริ่มต้นดำเนินการระยะเวลาสิ้นสุดดำเนินการ',
    BUDGET = 'ขอปรับเปลี่ยนข้อมูลการใช้เงิน',
}


export const expex_project_amendment_name_data: { label: string, value: string }[] = [
    {
        label: EDPEX_PROJECT_AMENDMENT_NAME.BUDGET,
        value: EDPEX_PROJECT_AMENDMENT_NAME.BUDGET,
    },
    {
        label: EDPEX_PROJECT_AMENDMENT_NAME.DURATION,
        value: EDPEX_PROJECT_AMENDMENT_NAME.DURATION,
    },
]

export enum EDPEX_PROJECT_AMENDMENT_STATUS {
    PENDING = 'PENDING', // รอพิจารณา
    APPROVED = 'APPROVE', // อนุมัติ
    REJECTED = 'REJECT', // ไม่อนุมัติ
}


export const edpex_project_amendment_status: { label: string, value: string }[] = [
    {
        label: "รอพิจารณา",
        value: EDPEX_PROJECT_AMENDMENT_STATUS.PENDING
    },
    {
        label: "อนุมัติ",
        value: EDPEX_PROJECT_AMENDMENT_STATUS.APPROVED
    },
    {
        label: "ไม่อนุมัติ",
        value: EDPEX_PROJECT_AMENDMENT_STATUS.REJECTED
    },
]